var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobTitleSearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #af4646;\n      }\n\n      .cls-2 {\n        opacity: .7;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 158,
    y: 83.08,
    width: 52.78,
    height: 20.08,
    rx: 10.04,
    ry: 10.04,
    transform: "translate(33.46 -47.92) rotate(16.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.72,42.86c-17.34,3.4-28.65,20.22-25.25,37.56,3.4,17.34,20.22,28.65,37.56,25.25,17.34-3.4,28.65-20.22,25.25-37.56-3.4-17.34-20.22-28.65-37.56-25.25ZM126.09,97.25c-12.38,2.43-24.37-5.64-26.8-18.01s5.64-24.37,18.01-26.8,24.37,5.64,26.8,18.01c2.43,12.38-5.64,24.37-18.01,26.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 151.69,
    y: 80.8,
    width: 9.8,
    height: 8.43,
    transform: "translate(36 -46.16) rotate(18.91)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M127.06,83.37c0,.63-.51,1.15-1.15,1.15h-6.89c-.63,0-1.15-.51-1.15-1.15v-3.45h-13.78v10.34c0,1.89,1.55,3.45,3.45,3.45h29.86c1.89,0,3.45-1.55,3.45-3.45v-10.34h-13.78v3.45ZM137.39,68.44h-5.74v-3.45c0-1.89-1.55-3.45-3.45-3.45h-11.48c-1.89,0-3.45,1.55-3.45,3.45v3.45h-5.74c-1.89,0-3.45,1.55-3.45,3.45v5.74h36.75v-5.74c0-1.89-1.55-3.45-3.45-3.45ZM127.06,68.44h-9.19v-2.3h9.19v2.3Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobTitleSearch);
export default __webpack_public_path__ + "static/media/job_title_search.f7037125124d92eb9f685810c8ee3bfa.svg";
export { ForwardRef as ReactComponent };